<template>
  <header class="header">
    <nav class="nav-header">
      <mq-layout v-if="userData" class="header-menu" mq="lg">
        <ul>
          <li v-for="(menuLink, index) in userData.MenuLinks" :key="menuLink.Text" >
              <router-link :to="menuLink.Href" exact v-if="!menuLink.IsOldLink" v-on:click.native="onMenuItemClick($event, menuLink)">
                <b-tooltip :position="getTooltipPosition(index)" multilined type="is-dark" :active="menuLink.LocalizationKey !== null">
                  <div v-html="menuLink.Text"></div>
                  <span class="material-icons not-allowed-package" v-if="menuLink.IsNotAllowed">lock</span>
                  <template #content>
                    <span v-if="menuLink.LocalizationKey !== null">{{ $t(`Header.Tooltips.${menuLink.LocalizationKey}`) }}</span>
                  </template>
                </b-tooltip>
              </router-link>
              <a :href="menuLink.Href" v-if="menuLink.IsOldLink" @click="onMenuItemClick($event, menuLink)">
                <b-tooltip :position="getTooltipPosition(index)" multilined type="is-dark" :active="menuLink.LocalizationKey !== null">
                  <div v-html="menuLink.Text"></div>
                  <span class="material-icons not-allowed-package" v-if="menuLink.IsNotAllowed">lock</span>
                  <template #content>
                    <span v-if="menuLink.LocalizationKey !== null">{{ $t(`Header.Tooltips.${menuLink.LocalizationKey}`) }}</span>
                  </template>
                </b-tooltip>
              </a>
          </li>
        </ul>
      </mq-layout>

      <mq-layout class="toggler-w" :mq="['sm', 'md']" :class="{ active: mobileMenu }">
        <div class="toggler" @click="showMobileMenu">
          <icon-base width="20" height="14" view-box="0 0 20 14" icon-name="bars"><icon-bars /></icon-base>
        </div>
      </mq-layout>

      <transition name="fade">
        <div v-if="mobileMenu" class="header-menu-m" :class="{ active: mobileMenu }">
          <div class="header-menu-m-container">
            <div class="header-menu-m-top">
              <div class="header-menu-m-h">
                <div class="header-menu-m-close" @click="hideMobileMenu">
                  <icon-base width="16" height="16" view-box="0 0 7 7" icon-name="times"><icon-times /></icon-base>
                </div>
                <div class="header-menu-m-logo">
                  <img alt="FixDigital" srcset="../../assets/logo-w.png, ../../assets/logo-w@2x.png 2x" src="../../assets/logo-w.png" />
                </div>
              </div>
              <div v-if="userData" class="header-menu-m-b">
                <ul>
                  <li v-for="menuLink in userData.MenuLinks" :key="menuLink.Text" @click="hideMobileMenu">
                    <router-link :to="menuLink.Href" exact v-if="!menuLink.IsOldLink" @click="onMenuItemClick($event, menuLink)">
                      <icon-base width="7" height="12" view-box="0 0 7 12" icon-name="caret-left"><icon-caret-left /></icon-base>
                      <div v-html="menuLink.Text"></div>
                      <span class="material-icons not-allowed-package" v-if="menuLink.IsNotAllowed">lock</span>
                    </router-link>
                    <a :href="menuLink.Href" v-if="menuLink.IsOldLink" @click="onMenuItemClick($event, menuLink)">
                      <icon-base width="7" height="12" view-box="0 0 7 12" icon-name="caret-left"><icon-caret-left /></icon-base>
                      <div v-html="menuLink.Text"></div>
                      <span class="material-icons not-allowed-package" v-if="menuLink.IsNotAllowed">lock</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="header-menu-m-bottom">
              <div class="header-lang">
                <div class="dropdown-w">
                  <b-dropdown scrollable aria-role="list" class="multiple" :max-height="400">
                    <template #trigger>
                      <b-button>
                        <span class="dropdown-trigger-value"
                          ><b>{{ $t("Header.Language.Caption") }}:</b> {{ currentLanguageTitle }}</span
                        >
                        <icon-base width="12" height="7" view-box="0 0 12 7" icon-name="caret-down"><icon-caret-down /></icon-base>
                      </b-button>
                    </template>
                    <b-dropdown-item aria-role="listitem" class="dropdown-item-link" href="/Profile/Index">{{ $t("Header.Profile") }}</b-dropdown-item>
                    <hr class="dropdown-divider" aria-role="menuitem" />
                    <b-dropdown-item aria-role="listitem" class="dropdown-caption">{{ $t("Header.Language.Caption") }}</b-dropdown-item>
                    <b-dropdown-item aria-role="listitem" class="dropdown-item-link" @click="changeLocale('en-US')">{{ $t("Header.Language.English") }}</b-dropdown-item>
                    <b-dropdown-item aria-role="listitem" class="dropdown-item-link" @click="changeLocale('he-IL')">{{ $t("Header.Language.Hebrew") }}</b-dropdown-item>
                    <hr class="dropdown-divider" aria-role="menuitem" />
                    <b-dropdown-item aria-role="listitem" class="dropdown-item-link" @click="logout()">{{ $t("Header.Logout") }}</b-dropdown-item>
                  </b-dropdown>
                </div>
              </div>
              <div class="header-email">
                <b-field>
                  <b-switch>{{ $t("Header.Emails") }}</b-switch>
                </b-field>
              </div>
            </div>
          </div>
          <div class="header-menu-m-bg"></div>
        </div>
      </transition>
    </nav>

    <nav v-if="userData" class="nav-acc">
      <div class="acc-item acc-links" style="display: none">
        <ul>
          <li>
            <a href="" class="is-transparent button-text-w">
              <span class="text">{{ $t("Header.StartTour") }}</span>
              <icon-base width="18" height="18" view-box="0 0 18 18" icon-name="play-square"><icon-play-square /></icon-base>
            </a>
          </li>
        </ul>
      </div>
      <a href="#" class="acc-item userinfo-btn" @click="showUserInfo">
        <span class="material-icons">info</span>
      </a>
      <HeaderNotifications />
      <HeaderUser />
    </nav>

    <div class="logo">
      <a href="/"><img alt="FixDigital" srcset="../../assets/logo.png, ../../assets/logo@2x.png 2x" src="../../assets/logo.png" /></a>
    </div>
  </header>
</template>

<script lang="ts">
import VueMq from "vue-mq";
import { Component, Vue } from "vue-property-decorator";
import { NavigationGuardNext, Route } from "vue-router";
import { Action, Getter } from "vuex-class";
import i18n from "@/i18n";
import router, { campaignsRoute, clientLeadsRoute, leadClientsRoute, leadsRoute } from "@/router";
import { RefreshGridMode } from "@/models/leads/ContactForm";
import { MenuLink, UserData } from "@/models/UserData";
import ConfigService from "@/services/ConfigService";
import HelperService from "@/services/HelperService";
import ApiService from "@/services/api/ApiService";
import HeaderNotifications from "./HeaderNotifications.vue";
import HeaderUser from "./HeaderUser.vue";
import IconBase from "../IconBase.vue";
import IconCaretDown from "../icons/IconCaretDown.vue";
import IconPlaySquare from "../icons/IconPlaySquare.vue";
import IconBars from "../icons/IconBars.vue";
import IconTimes from "../icons/IconTimes.vue";
import IconCaretLeft from "../icons/IconCaretLeft.vue";

Vue.use(VueMq, {
  breakpoints: {
    sm: 576,
    md: 992,
    lg: Infinity,
  },
  defaultBreakpoint: "sm",
});

const namespace = "mainModule";

@Component({
  components: {
    IconBase,
    IconCaretDown,
    IconPlaySquare,
    IconBars,
    IconTimes,
    IconCaretLeft,
    HeaderNotifications,
    HeaderUser,
  },
})
export default class Header extends Vue {

  //#region Vuex getters and actions

  @Getter("userData", { namespace }) userData!: UserData;
  @Action("getUserData", { namespace }) getUserData!: () => Promise<UserData>;
  @Action("setNeedToRefreshCampaignsGrid", { namespace: "campaignsModule" }) setNeedToRefreshCampaignsGrid!: (needToRefreshCampaignsGrid: RefreshGridMode) => void;
  @Action("setNeedToRefreshLeadsGrid", { namespace: "leadsModule" }) setNeedToRefreshLeadsGrid!: (needToRefreshLeadsGrid: RefreshGridMode) => void;
  @Action("setUserData", { namespace }) setUserData!: (userData: UserData | null) => void;

  //#endregion Vuex getters and actions


  //#region Properties

  routeChanged = false;

  //#endregion Properties


  //#region Lifecycle

  mounted(): void {
    router.beforeEach((to: Route, from: Route, next: NavigationGuardNext<Vue>) => {
      this.routeChanged = true;
      next();
    });
  }

  //#endregion Lifecycle
  

  public mobileMenu = false;

  get currentLanguageTitle(): string {
    switch (this.$i18n.locale) {
      case "en-US":
        return "English";
      case "he-IL":
        return "עברית";
    }
    return this.$i18n.locale;
  }

  public showMobileMenu(): void {
    this.mobileMenu = true;
    this.popupBodyOn();
  }

  public hideMobileMenu(): void {
    this.mobileMenu = false;
    this.popupBodyOff();
  }

  public popupBodyOn(): void {
    document.body.style.top = "-" + window.scrollY + "px";
    document.body.style.position = "fixed";
  }

  public popupBodyOff(): void {
    const scrollY = document.body.style.top;
    document.body.style.position = "";
    document.body.style.top = "";
    window.scrollTo(0, parseInt(scrollY || "0") * -1);
  }

  changeLocale(locale: string): void {
    this.$i18n.locale = locale;
    localStorage.locale = locale;
    ApiService.setLanguage(locale);
  }

  logout() {
    ApiService.logout().then(() => {
      this.setUserData(null);
      location.href = ConfigService.loginUrl;
    });
  }
  
  onMenuItemClick(e: Event, menuLink: MenuLink) {
    if (menuLink.IsNotAllowed) {
      e.preventDefault();
      HelperService.showConfirmDialog(i18n.t("NotAllowedPopup.Title").toString(), i18n.t("NotAllowedPopup.Content").toString(),
            i18n.t("NotAllowedPopup.Button").toString(), i18n.t("Cancel").toString(),
            () => {
              window.open(menuLink.Href);
            });
    }
    if (!this.routeChanged) {
      if (menuLink.Href === leadsRoute && router.currentRoute.fullPath === leadsRoute
          || menuLink.Href === clientLeadsRoute && router.currentRoute.fullPath === clientLeadsRoute
          || menuLink.Href === leadClientsRoute && router.currentRoute.fullPath === leadClientsRoute) {
        this.setNeedToRefreshLeadsGrid(RefreshGridMode.Full);
      } else if (menuLink.Href === campaignsRoute && router.currentRoute.fullPath === campaignsRoute) {
        this.setNeedToRefreshCampaignsGrid(RefreshGridMode.Full);
      }
    }
    
    this.routeChanged = false;
  }

  showUserInfo(e: Event) {
    e.preventDefault();
    let messageParts: string[] = [];
    messageParts.push(`${i18n.t("Header.UserInfoPopup.Id")}: ${this.userData.Id}`);
    messageParts.push(`${i18n.t("Header.UserInfoPopup.TenantId")}: ${this.userData.TenantId}`);
    if (this.userData.ClientId) {
      messageParts.push(`${i18n.t("Header.UserInfoPopup.ClientId")}: ${this.userData.ClientId}`);
    }
    messageParts.push(`${i18n.t("Header.UserInfoPopup.Name")}: ${this.userData.Name}`);
    messageParts.push(`${i18n.t("Header.UserInfoPopup.Email")}: ${this.userData.Email}`);
    messageParts.push(`${i18n.t("Header.AnyDesk")}`);
    HelperService.showMessage(i18n.t("Header.UserInfoPopup.Title").toString(), messageParts.join("<br />"), i18n.t("OK").toString());
  }
  
  getTooltipPosition(index: number): string {
    if(index != 0 && this.$i18n.locale === "he-IL" || index != this!.userData!.MenuLinks!.length - 1 && this.$i18n.locale === "en-US")
      return "is-bottom";
    return "is-left";
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables";

.header {
  padding: 0 30px;
  display: flex;
  align-items: stretch;
  background: #fff;
  font-size: 17px;
  box-shadow: 1px 1px 4px rgba(38, 50, 56, 0.2);
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  z-index: 100;
  @media (min-width: 2000px) {
    padding: 0 60px;
  }
  @media (min-width: 1900px) {
    
    padding: 0 30px;
    font-size: 18px;
  }
  @media (max-width: 1899px) {
    font-size: 16px;
    padding: 0 20px;
  }
  @media (max-width: 1599px) {
  }
  @media (max-width: 991px) {
    padding: 0 10px 0 15px;
  }
  @media (max-width: 575px) {
  }
}

.logo {
  padding: 13px 0 12px;
  margin-right: 30px;
  line-height: 0;
  flex: 0 0 190px;
  @media (max-width: 1799px) {
    margin-right: 20px;
  }
  @media (resolution: 120dpi) and (max-width: 1999px) {
    flex: 0 0 152px;
    display: flex;
    align-items: center;
  }
  
  @media (max-width: 1599px) {
    margin-right: 12px;
    flex: 0 0 152px;
  }  
  @media (max-width: 1140px) {
    flex: 0 0 100px;
    align-self: center;
  }
  @media (max-width: 575px) {
    margin-right: 10px;
  }
  a {
    display: block;
    line-height: 0;
  }
}

.nav-acc {
  padding: 12px 0 13px;
  display: flex;
  align-items: stretch;
  
  @media (max-width: 991px) {
    margin-left: auto;
  }
}

.acc-item {
  position: relative;
  padding: 0 25px;
  @media (max-width: 1899px) {
    padding: 0 15px;
  }
  @media (max-width: 1599px) {
    padding: 0 10px;
  }
  @media (max-width: 359px) {
    padding: 0 5px;
  }
  &:after {
    content: "";
    display: block;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    height: 28px;
    width: 1px;
    background: $lightd;
    @media (max-width: 991px) {
      display: none;
    }
  }
}

.acc-links {
  display: flex;
  align-items: stretch;
  @media (max-width: 991px) {
    margin-right: 10px;
  }
  @media (max-width: 359px) {
    margin-right: 5px;
  }
  .button-text-w {
    .text + .icon-w {
      color: $primary;
      margin: 0 12px 0 0;
      @media (max-width: 1599px) {
        margin-right: 0;
      }
    }
    .text {
      @media (max-width: 1599px) {
        display: none;
      }
    }
    &:hover {
      .icon-w {
        color: lighten($primary, 3%);
      }
    }
  }
  ul {
    display: flex;
    align-items: center;
  }
  a {
    white-space: nowrap;
    font-weight: 600;
  }
}

.nav-header {
  display: flex;
  align-items: stretch;
  margin-left: auto;
  padding: 0;
  @media (max-width: 991px) {
    margin-left: 0;
  }
  .header-menu {
    display: flex;
    align-items: stretch;
    ul {
      display: flex;
      align-items: stretch;
      @media (max-width: 991px) {
        position: absolute;
        top: 66px;
        left: 10px;
        right: 10px;
        bottom: 10px;
        background: #fff;
      }
      li {
        display: flex;
        align-items: stretch;
        margin-left: 20px;
        @media (min-width: 1800px) {
          margin-left: 22px;
        }
        @media (max-width: 1799px) {
          margin-left: 12px;
        }
        @media (max-width: 1599px) {
          margin-left: 5px;
          letter-spacing: -0.01em;
        }
        @media (max-width: 1140px) {
          letter-spacing: -0.02em;
        }
        
        @media (max-width: 991px) {
          letter-spacing: -0.01em;
        }

        
        a {
          color: $dark;
          white-space: nowrap;
          padding: 17px 4px 18px;
          line-height: 21px;
          font-weight: 600;
          position: relative;
          @media (max-width: 1999px) {
            font-size: 16px;
          }
          @media (max-width: 1599px) {
            font-size: 14px;
          }
          @media (max-width: 1140px) {
            padding: 17px 3px 18px;
          }
          
          @media (max-width: 991px) {
            padding: 17px 4px 18px;
          }
          @media (resolution: 120dpi) {
            font-size: 14px;
          }
          &.is-active {
            color: #1ca8d9;
            position: relative;
            &:after {
              content: "";
              display: block;
              position: absolute;
              left: 0;
              right: 0;
              bottom: 0;
              height: 4px;
              background: #1ca8d9;
            }
          }

          .not-allowed-package {
            color: #e55353;
            font-size: 15px;
            position: absolute;
            right: -3px;
            top: -6px;
          }
        }
      }
    }
  }

  .toggler-w {
    display: flex;
    .toggler {
      padding: 5px;
      display: flex;
      align-items: center;
      cursor: pointer;
      align-self: center;
      .icon-w {
        transition: all 0.2s;
      }
      &:hover {
        .icon-w {
          color: #1ca8d9;
        }
      }
    }
  }

  .header-menu-m {
    .header-menu-m-container {
      position: fixed;
      top: 0;
      right: 0;
      width: 100%;
      height: 100%;
      z-index: 10;
      background: linear-gradient(90deg, $primary 0%, #1ca8d9 52.75%);
      transition: all 0.5s;
      // transform: translateX(0);
      .header-menu-m-top {
        color: #fff;
        .header-menu-m-h {
          position: fixed;
          top: 0;
          left: 0;
          height: 56px;
          width: 100%;
          display: flex;
          padding: 13px 10px 12px 15px;
          &:after {
            content: "";
            position: absolute;
            bottom: 0;
            left: 20px;
            right: 20px;
            height: 1px;
            background: rgba(255, 255, 255, 0.25);
          }
          .header-menu-m-close {
            padding: 7px 10px;
            cursor: pointer;
            transition: all 0.2s;
            &:hover {
              opacity: 0.8;
            }
            .icon-w {
              svg {
              }
            }
          }
          .header-menu-m-logo {
            margin-right: auto;
            line-height: 0;
            img {
            }
          }
        }
        .header-menu-m-b {
          position: fixed;
          top: 56px;
          bottom: 75px;
          left: 0;
          width: 100%;
          padding: 0 20px;
          overflow-y: auto;
          @media (max-width: 359px) {
            bottom: 90px;
          }
          ul {
            li {
              a {
                display: flex;
                align-items: center;
                padding: 15px 0;
                color: #fff;
                line-height: 24px;
                font-size: 19px;
                transition: all 0.2s;
                &:hover {
                  span {
                    opacity: 0.8;
                  }
                }
                .icon-w {
                  margin-left: 9px;
                }

                &.is-active {
                  //background: linear-gradient(to right, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, .15) 30%, rgba(255, 255, 255, .15) 70%, rgba(255, 255, 255, 0) 100%);
                  background: #fff;
                  color: $primary;
                  margin: 0 -20px;
                  padding: 15px 20px;
                  span {
                    // opacity: 0.8;
                  }
                }
              }
              &:not(:last-child) {
                a {
                  border-bottom: 1px solid rgba(255, 255, 255, 0.25);
                }
              }
            }
          }
        }
      }

      .header-menu-m-bottom {
        font-size: 16px;
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        background: #fff;
        box-shadow: 1px 1px 4px rgba(38, 50, 56, 0.2);
        padding: 20px;
        z-index: 1;
        display: flex;
        align-items: center;
        @media (max-width: 359px) {
          display: block;
          padding: 10px 20px;
        }
        .header-lang {
          @media (max-width: 359px) {
            margin-bottom: 10px;
          }
        }
        .header-email {
          margin-right: auto;
          min-height: 25px;
        }
      }
    }
    .header-menu-m-bg {
      position: fixed;
      top: 0;
      right: 0;
      width: 100%;
      height: 100%;
      z-index: 9;
      transition: all 0.5s;
      background: rgba(0, 0, 0, 0.3);
      // opacity: 0;
    }

    &.fade-enter-active,
    &.fade-leave-active {
      z-index: 101;
      transition: all 0.5s;
    }
    &.fade-enter,
    &.fade-leave-to,
    &.fade-leave-active {
      opacity: 1;
      .header-menu-m-container {
        transform: translateX(100%);
      }
      .header-menu-m-bg {
        opacity: 0;
      }
    }
    &.active {
      z-index: 101;
      .header-menu-m-container {
        // transform: translateX(0);
      }
      .header-menu-m-bg {
        // opacity: 1;
      }
    }
  }
}

.userinfo-btn {
  align-items: center;
  color: #333;
  display: flex;
}

html[dir="ltr"] {
  .header {
    flex-direction: row-reverse;
    .nav-header {
      .header-menu-m {
        .header-menu-m-container {
          .header-menu-m-h {
            flex-direction: row-reverse;
          }
          .header-menu-m-b {
            ul {
              li {
                a {
                  .icon-w {
                    margin: 0 9px 0 0;
                    transform: scaleX(-1);
                  }
                }
              }
            }
          }
          .header-menu-m-bottom {
            .header-email {
              margin: 0 0 0 auto;
            }
          }
        }
      }
    }
  }
  .nav-acc {
    flex-direction: row-reverse;
  }
  .acc-links a {
    flex-direction: row-reverse;
  }
}

html[dir="rtl"] {
  .nav-header {
    .header-menu {
      ul {
        li {
          a {
            .not-allowed-package {
              left: -9px;
              right: auto;
            }
          }
        }
      }
    }
  }
}
</style>
